<template>
<div>
  <el-dialog title="个人客户信息" :visible.sync="visable" :close-on-click-modal="false" :before-close="hide" width="1200px">
    <div style="display: flex;flex-direction: row;margin-bottom: 10px;">
      <el-button size="mini" @click="submit">保存</el-button>
      <el-button size="mini" @click="hide">取消</el-button>
    </div>
    <el-descriptions size="mini" :column="1" border direction="vertical">
      <el-descriptions-item label="应收款明细信息">
        <div>
          <el-descriptions size="mini" :label-style="{width: '100px'}" :column="1" border>
            <el-descriptions-item label="结转日期">
              <el-date-picker
                v-model="form.carry_forward_date"
                type="date"
                size="mini"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                placeholder="选择日期">
              </el-date-picker>
            </el-descriptions-item>
            <el-descriptions-item label="收费项">
              <el-checkbox-group v-model="chang_name_ids">
                <el-checkbox size="mini"  v-for="(item,index) in chang_name_list" :key="index" :label="item.id">{{item.chargeItem_name}}</el-checkbox>
              </el-checkbox-group>
            </el-descriptions-item>
            <el-descriptions-item label="操作">
              <el-button size="mini" @click="getData">筛选收费项</el-button>
              <el-button v-if="multipleSelection.length" size="mini" type="danger" style="color: #ffffff" @click="removeOrder()">移除应收款</el-button>
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <div style="overflow-x: scroll;width: 100%;display: grid;">
          <el-table
            v-if="pageData" v-loading="loading" :data="pageData.list"
            border
            @selection-change="handleSelectionChange"
            style="width: 100%" height="400">
            <el-table-column
              type="selection"
              width="45"></el-table-column>
              <el-table-column prop="customer_name" label="客户名称" align="center" width="180"></el-table-column>
              <el-table-column prop="number" label="是否在流程中 " align="center" width="100"></el-table-column>
              <el-table-column prop="h_name_date" label="房 产" align="center" width="320"></el-table-column>
              <el-table-column prop="ChargeItemName" label="收费标准" align="center" width="240"></el-table-column>
              <el-table-column prop="startDate" label="计费周期" align="center" width="240">
                <template slot-scope="scope">
                  {{scope.row.startDate}} - {{scope.row.endDate}}
                </template>
              </el-table-column>
              <el-table-column prop="should_charge_date" label="应收日期" align="center" width="150"></el-table-column>
              <el-table-column prop="charge" label="应收金额" align="center" width="90"></el-table-column>
              <el-table-column prop="PaidChargeSum" label="已收金额" align="center" width="90"></el-table-column>
              <el-table-column prop="account" label="挂账金额" align="center" width="90"></el-table-column>
<!--              <el-table-column prop="house_name" label="手动" align="center" width="80" fixed="right">-->
<!--                <template slot-scope="scope">-->
<!--                  <el-checkbox size="mini" v-model="scope.row.checkbox" @change="changeCheckbox(scope.row)"></el-checkbox>-->
<!--                </template>-->
<!--              </el-table-column>-->
<!--              <el-table-column prop="house_name" label="老客户" align="center" width="120" fixed="right">-->
<!--                <template slot-scope="scope">-->
<!--                  <el-input size="mini" placeholder="老业主金额" :disabled="!scope.row.checkbox" @input="onDosageNumber(scope.row,'old_money')" v-model="scope.row.old_money" clearable></el-input>-->
<!--                </template>-->
<!--              </el-table-column>-->
<!--              <el-table-column prop="house_name" label="新客户" align="center" width="120" fixed="right">-->
<!--                <template slot-scope="scope">-->
<!--                  <el-input size="mini" placeholder="新业主金额" :disabled="!scope.row.checkbox" @input="onDosageNumber(scope.row,'new_money')" v-model="scope.row.new_money" clearable></el-input>-->
<!--                </template>-->
<!--              </el-table-column>-->
          </el-table>
        </div>
      </el-descriptions-item>
    </el-descriptions>
  </el-dialog>
</div>
</template>

<script>
export default {
  name: "CustomerSaleCarryOver",
  data(){
    return{
      loading:false,
      visable:false,
      form:{
        carry_forward_date:""
      },
      chang_name_ids:[],
      multipleSelection:[],
      pageData: {
        list: [],
        total: 0,
        pageSize: 15,
        page: 1
      },
      callback:null,
      chang_name_list:[],
      house_sale_log_id:0,
    }
  },
  methods:{
    getOrderChangName(callback){
      const that=this;
      ERP.getRequest({url: "admin/HouseSale/getOrderChangName", data: {
          house_id:that.house_id
        }
      }, res => {
        if (res.code) {
          that.chang_name_list=res.data
          that.chang_name_ids=res.data.map(ret=>ret.id)
          typeof callback==="function"&&callback()
        }
      })
    },
    getData(){
      const that=this;
      that.loading=true;
      that.multipleSelection=[];
      ERP.getRequest({url: "admin/HouseSale/getOrderList", data: {
          house_id:that.house_id,
          chang_name_ids:that.chang_name_ids.join(',')
        }
      }, res => {
        if (res.code) {
          // console.log(res.data);
          res.data.map(ret=>{
            ret.checkbox=false;
            ret.old_money="";
            ret.new_money="";
            return ret;
          })
          that.pageData.list=res.data
        }
        that.loading=false;
      })

    },
    // onDosageNumber(item,name="old_money"){
    //   if(item.checkbox){
    //     if(name==='old_money'){
    //       item.new_money=item.charge-item.old_money;
    //     }else {
    //       item.old_money=item.charge-item.new_money;
    //     }
    //
    //   }
    // },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // changeCheckbox(item){
    //   if(!item.checkbox){
    //     item.old_money="";
    //     item.new_money="";
    //   }
    // },
    removeOrder(){
      const that=this;
      let select_ids=that.multipleSelection.map(ret=>ret.id);
      let list=that.pageData.list.filter(ret=>(select_ids.indexOf(ret.id)===-1));
      // console.log(list);
      that.pageData.list=reObject(list)
      that.multipleSelection=[];
    },
    show(data){
      // console.log(data)
      const that=this;
      that.callback=data.callback;
      that.house_id=data.house_id;
      that.house_sale_log_id=data.house_sale_log_id;
      that.visable=true;
      that.$forceUpdate();
      that.getOrderChangName(()=>{
        that.getData();
      })
    },
    hide(){
      this.callback();
      this.callback=undefined;
      this.house_id=undefined;
      this.pageData= {
        list: [],
        total: 0,
        pageSize: 15,
        page: 1
      }
      this.visable=false;
    },
    submit(){
      const that=this;
      if(!that.house_sale_log_id){
        that.$message.error('无提交日志信息')
      }
      ERP.postRequest({url: "admin/HouseSale/splitOrder", data: {
          house_sale_log_id:that.house_sale_log_id,
          split_date:that.form.carry_forward_date,
          list_str:JSON.stringify(that.pageData.list)
        }
      }, res => {
        if (res.code) {
          that.hide();
        }else {
          that.$message.error(res.msg||'数据查询失败');
        }
      })
    }
  }
}
function reObject(item) {
  return JSON.parse(JSON.stringify(item));
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/User/CustomerManagement/components/CustomerSaleCarryOver.vue